import { ModalOption } from '../../interface/IModal';

// * Init Options
export const initialOptions: ModalOption = {
    customClass: '', // Custom class for custom design
    isVertical: true, // Toast type (true ? vertical : horizontal)
    position: 'center', // Modal position ('top-start', 'top', 'top-end', 'center-start', 'center', 'center-end', 'bottom-start', 'bottom', 'bottom-end')
    title: '', // Title html or text
    html: '', // Content html or text
    width: undefined, // Modal content width
    allowOutsideClick: true, // Allow close modal to click outside
    timer: undefined, // Autoclose timer
    showCloseButton: true, // Show close button
    showConfirmButton: true, // Show confirm button
    showCancelButton: false, // Show cancel button
    confirmButtonText: '확인', // Confirm button text
    cancelButtonText: '취소', // Cancel button text
    confirmButtonColor: undefined, // Confirm button color
    cancelButtonColor: undefined, // Cancel button color
    showClass: '', // Show animation class
    hideClass: '', // Hide animation class
    willOpen: undefined, // Execute when modal is open
    preConfirm: undefined, // Execute when click confirm
    willClose: undefined, // Execute when click cancel
    allowEscapeKey: true, // Allow Esc keyboardEvent
    allowEnterKey: true, // Allow Enter keyboardEvent
} as const;

// * Default Options
export const toastDefaultOptions: Partial<ModalOption> = {
    position: 'bottom',
};

export const confirmDefaultOptions: Partial<ModalOption> = {
    showCloseButton: false,
    showCancelButton: true,
};

export const alertDefaultOptions: Partial<ModalOption> = {
    showCloseButton: false,
};

export const layerDefaultOptions: Partial<ModalOption> = {
    showCancelButton: true,
};
